<div class="card pt-0 mb-5">
    <div class="card-header">
        <h4>Blocked Entity List</h4>
      </div>
    <div class="card-body">
    </div>

    <div class="card-body m-0">
      <div class="row mb-2">
        <div class="col-xl-10">       
          <!-- <button type="button" class="btn bg-danger-custom" (click)="onExportCSV()">
            Download<i class="feather icon-download"></i></button> -->
          <button type="button" class="btn bg-danger-custom" 
            (click)="quickFilterShowAction($event)">Quick Filters<i class="feather icon-filter"></i></button>
            <!-- <button type="button" class="btn bg-danger-custom" (click)="onExportCSV()">
              Download<i class="feather icon-download"></i></button> -->
      <!--<div class="btn-group mb-1 mb-md-0">
            <div class="btn-group" ngbDropdown role="group">
              <button class="btn bg-danger-custom" ngbDropdownToggle>Columns</button>
              <div ngbDropdownMenu class="ng-dropdown-panel-items p-1"
                style="height: 250px;width: 250px; overflow: scroll; scroll-behavior: smooth">
                <div class="form-group">              
                  <div *ngIf="columnDefs" class="list-group ng-option">
                    <span *ngFor="let column of columnDefsCopy; let i = index" class="checkbox">
                      <label class="list-group-item p-2">
                        <input class="form-check-input me-1" type="checkbox" value="{{i}}" name="{{column.headerName}}"
                          (change)="updateSelectedColumn($event)"
                          [checked]="(tableSelectedColumn && (-1 !==tableSelectedColumn.indexOf(column)) ? 'checked': '')" />
                        {{(column?.headerName?.replace('_','') || column?.field?.replace('_','') ) }}
                      </label>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div> -->
        </div>     
      </div>    
      <div *ngIf="quickFilterShow" class="row" style="min-height: 100px">
          <div class="card">
            <div class="card-body">
              <div class="row">

                <div class="col-md-4">
                 
                  <label class="col-form-label">Entity Type</label>
                  <!-- <input type="text" autocomplete="new-password" formControlName="Status"> -->
                  <ng-select aria-label="Default select example" formControlName="Status" placeholder="Select Entity Type"
                          >
                          <ng-option value="null" [disabled]="true" >Select Entity Type</ng-option>
                          <ng-option value="Merchant" >Merchant</ng-option>
                          <ng-option value="Agent" >Agent</ng-option>
                          <ng-option value="Subagent"  >Subagent</ng-option>
                          <ng-option value="Customer"  >Customer</ng-option>
                    <!-- <option [selected]="true"  value="" selected disabled>Select Merchant Status</option> -->
                    <!-- <option *ngFor="let merchantstatuslist of Resdata" [value]="merchantstatuslist.FieldValue">
                      {{merchantstatuslist.FieldText}}</option> -->
                  </ng-select>
                  <div  class="invalid-feedback">
                    Please fill this field
                  </div>
    
    
              
              </div>
                <div class="col-md-4">
                  <!-- <div class="row"> -->
                  <label class="col-form-label" for="searchMerName">Search by Legal Name</label>
                  <!-- <div class="col-md-8"> -->
                  <!-- <input (keyup.enter)="onSearchBtnClick($event)" [(ngModel)]="searchMerName" class="form-control"
                  maxlength="50" id="searchMerName" (keyup)="allowAlfanumeric($event)"
                  (keypress)="OnlyCharacterAllowed($event)" (change)="allowAlfanumeric($event)" type="text" autocomplete="new-password" />
               -->
  
                  <ng-select #filSearchMerName (change)="searchbyMerchantName($event)"
                    id="searchMerName" 
                    (change)="allowAlfanumeric($event)" placeholder="Search by Legal Name"
                    [inputAttrs]="{maxlength: '200'}" >
                    <ng-option *ngFor="let merchant of Resultdata" [value]="merchant.merchant_name">
                      {{merchant.merchant_name}}
                    </ng-option>
                  </ng-select>
  
                  <!-- </div> -->
  
                  <!-- </div> -->
                </div>
                <div class="col-md-4">
                  <label class="col-form-label" for="searchMerName">Entity Name</label>                 
                  <ng-select  
                  placeholder="Entity Name" (change)="searchbypayid($event)">
                  <ng-option *ngFor="let merchant of Resultdata" [value]="merchant.MerchantId">
                    {{merchant.merchant_name}} ({{merchant.MerchantId}})
                  </ng-option>
                </ng-select>
                </div>
                <div class="col-md-4">
                  <label class="col-form-label" for="businessType">Business Type <span aria-hidden="true"
                                                                                       class="symbol required"
                                                                                       style="color:red;">*</span>
                  </label>
                
                   
                    <ng-select  
                    placeholder="Business Type" (change)="onselectBusinessType($event)">
                    <ng-option *ngFor="let merchant of businessTypeOptions" [value]="merchant.FieldValue">
                      {{merchant.FieldText}} 
                    </ng-option>
                  </ng-select>  



                  
                    
                </div>
                <div class="col-md-4">
                  <!-- <div class="row"> -->
                  <label class="col-form-label">Search by Business Category</label>  
                              
                  <ng-select    [(ngModel)]="searchMerName"  maxlength="50" id="searchMerName"                  
                    (change)="onselectBusinessCat($event)">
                    <ng-option *ngFor="let categoryType of categoryTypeOptions" [value]="categoryType.id">
                      {{categoryType?.bussinessCategories}}
                    </ng-option>
                  </ng-select>              


                </div>
                <div class="col-md-4">               
                  <label class="col-form-label" >Search by Business Sub-Category</label>                  
                  <ng-select #subCategorySearch  (change)="onselectBusinessSubCat($event)" [(ngModel)]="searchMID" 
                  id="searchMID" maxlength="10" >
                    <ng-option *ngFor="let subCategory of subCategoryTypeOptions" [value]="subCategory.id">
                      {{subCategory?.bussinessSubCategories}} 
                    </ng-option>
                  </ng-select>               


                </div>
                
                <!-- <div class="col-md-4">
                  <label class="col-form-label" for="resellerPartnerId">Search by Risk Level Code</label>  
                  <input type="text" class="form-control form-control-solid" formControlName="passportNumber" id="passportNumber">                -->
                  <!-- <ng-select #risksearch  (change)="onselectRiskLevelCode($event)" 
                  id="resellerPartnerId" maxlength="10" >
                    <ng-option *ngFor="let riskcodevalue of riskcode" [value]="riskcodevalue?.value">
                      {{riskcodevalue?.code}} 
                    </ng-option>
                  </ng-select> -->
                <!-- </div> -->
              </div>
            </div>
          </div>         
          <div class="mb-3 col-md-2" style="margin-top: 4%;">
            <!-- <div class="row"> -->
            <!-- <div class="col-md-12"> -->
            <!-- <label class="col-form-label" for="searchMID">Search</label> -->
            <!-- </div>            -->
            <!-- <div class="col-md-6"> -->
            <button (click)="getNegativeMerchantReport()" class="btn bg-danger-custom" type="button"><i
                class="feather icon-search"></i>Search
            </button>
            <!-- </div> -->
            <!-- </div> -->
          </div>
      </div>     
    <!-- </div> -->
<!-- </div> -->
<div class="row" style="min-height: 300px">
    <div class="col-12 col-xl-12 grid-margin stretch-card ag-theme-alpine">
      <ag-grid-angular [enableCellTextSelection]=true  (filterModified)="onFilterModified($event)"
        (filterOpened)="onFilterOpened($event)" (gridReady)="onGridReady($event)" (rowClicked)="onRowClicked($event)"
        (rowDoubleClicked)="onRowDoubleClicked($event)" [columnDefs]="tableSelectedColumn" [defaultColDef]="defaultColDef"
        [paginationPageSize]="pageSize" [pagination]="true" [rowData]="rowData" [rowModelType]=""
        [rowSelection]="'single'" [suppressPaginationPanel]="true" class="ag-theme-alpine"
        style="width: 100%; height: auto;">
      </ag-grid-angular>
    </div>
  </div>
  <div class="row bg-white p-2 mt-0">
  <div class="col-md-4">
    <select (change)="onPageSizeChanges($event)" [(ngModel)]="pageSize"
      class="form-select d-flex justify-content-end col-4" name="pageSize" style="width: auto">
      <option [ngValue]="10">10</option>
      <option [ngValue]="20">20</option>
      <option [ngValue]="30">30</option>
    </select>
  </div>
  <div class="col-md-8">
    <ngb-pagination (pageChange)="onPaginationChange($event)" [(page)]="currentPage" [boundaryLinks]="true"
      [collectionSize]="collectionSize" [maxSize]="5" [pageSize]="pageSize" [rotate]="true"
      class="d-flex justify-content-end col-8 align-right">
    </ngb-pagination>
  </div>
  </div>
</div>
</div>